import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=10c153f7&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c153f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c153f7')) {
      api.createRecord('10c153f7', component.options)
    } else {
      api.reload('10c153f7', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=10c153f7&scoped=true&", function () {
      api.rerender('10c153f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KcmWR5hIX4D8/JS/comp/SearchFilterTokens.vue"
export default component.exports